import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as selector from '../../selectors';

const mapStateToProps = state => {
	return {
		settings: selector.getSettings(state),
		momentTimezone: selector.getMomentTimezone(state),
		momentTimezoneOffset: selector.getMomentTimezoneOffset(state),
	};
};

@connect(mapStateToProps)
export default class extends Component {
	static propTypes = {
		settings: PropTypes.object,
		momentTimezone: PropTypes.object,
		momentTimezoneOffset: PropTypes.object,
	}

	render() {
		const {
			settings,
			momentTimezone,
			momentTimezoneOffset,
		} = this.props;

		const {open, close} = settings;
		const tempClosed = !!Number(settings.closed);

		const weekdayNum = momentTimezoneOffset.format('E');
		const _open = settings['open_' + weekdayNum] || open;
		const _close = settings['close_' + weekdayNum] || close;

		const now = momentTimezone;
		const today = momentTimezoneOffset.startOf('day');
		const momentOpen = today.clone().add({hours: _open});
		const momentClose = today.clone().add({hours: _close});

		let status;
		let statusClassName;
		let willOpen, willClose;
		let closed;
		if (close - open === 24) {
			closed = false;
			status = 'Сейчас открыто';
			statusClassName = 'status_open';
			willClose = 'Работает круглосуточно';
		} else if (now.isBetween(momentOpen, momentClose, null, '[)')) {
			closed = false;
			status = 'Сейчас открыто';
			statusClassName = 'status_open';
			willClose = 'Закроется в ' + momentClose.format('HH:00');
		} else {
			closed = true;
			status = 'Сейчас закрыто';
			statusClassName = 'status_closed';
			willOpen = 'Откроется в ' + momentOpen.format('HH:00');
		}

		return (
			<div className="work_hours">
				{tempClosed ? (
					<p>
						<span className="status_closed">Временно закрыто</span>
					</p>
				) : (
					<p>
						<span className={statusClassName}>{status} &nbsp;&middot;&nbsp; </span>
						<span>{closed ? willOpen : willClose}</span>
					</p>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/widgets/WorkHours.js